const isProduction: boolean = process.env.NODE_ENV === 'production';
const prefix: string = 'Invariant failed';

/**
 * A lightweight invariant function for runtime assertions
 * Throws an error if the condition is falsy
 *
 * Inspired by tiny-invariant without the dependency
 *
 * @param condition - The condition to check
 * @param message - Optional error message (omitted in production builds)
 * @throws {Error} When condition is falsy
 *
 * @example
 * invariant(user, 'User must be defined');
 */
export default function invariant(
    condition: any,
    message?: string | (() => string),
): asserts condition {
    if (condition) {
        return;
    }

    if (isProduction) {
        throw new Error(prefix);
    }

    const provided: string | undefined = typeof message === 'function' ? message() : message;

    const value: string = provided ? `${prefix}: ${provided}` : prefix;
    throw new Error(value);
}
